// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18Wqo","title":"styles_title__2ZxxB"};